export default __webpack_public_path__ + "static/media/Under_Constrution.879929cb.svg";